import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class EngagementHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllContacts(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/engagement/getAllContacts`);
    }

    getAllSurvey(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/engagement/getAllSurvey`);
    }

    getAllReviews(): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/engagement/getAllReviews`);
    }

    togglePublishReview(productReviewsId: any, value: any): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/engagement/togglePublishReview`,
            {},
            {
                params: { productReviewsId: productReviewsId, value: value },
            }
        );
    }
}
